import {Grid, LinkButton, Typography, useReachGoalCallback} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback, useEffect} from 'react'

import {config} from 'src/shared/config'
import {Brand} from 'src/shared/types'

import {useMarginRef} from '../../margin-provider'
import {DOWNLOAD_YANDEX_APP, DOWNLOAD_YANGO_APP} from '../../promo'
import {classes} from './PostcardBanner.classes'

type Props = {
  imageSrc: string
}

const PostcardBanner: React.FC<Props> = ({imageSrc}) => {
  const t = useI18n()
  const isYango = config.brand === Brand.Yango
  const reachGoal = useReachGoalCallback()
  const clickHandler = useCallback(() => reachGoal('PushInstallButtonClicked'), [reachGoal])
  const ref = useMarginRef<HTMLDivElement>(el => ({
    top: el.offsetHeight,
  }))

  useEffect(() => reachGoal('PushSeen'), [reachGoal])

  return (
    <div ref={ref} className={classes.root}>
      <Grid alignItems="center" spacing={1} wrap="nowrap" container>
        <Grid className={classes.postcardRoot} item>
          <div className={classes.postcard}>
            <div className={classes.imageRoot}>
              <div className={classes.image} style={{backgroundImage: `url(${imageSrc})`}} />
            </div>
          </div>
        </Grid>
        <Grid item xs>
          <Typography group="normal" thickness="regular" variant="caption1">
            {isYango ? t('yango_route_postcard_banner_text') : t('route_postcard_banner_text')}
          </Typography>
        </Grid>
        <Grid item>
          <LinkButton
            className={classes.button}
            href={isYango ? DOWNLOAD_YANGO_APP : DOWNLOAD_YANDEX_APP}
            onPress={clickHandler}
            target="_blank"
            variant="action"
          >
            {t('route_postcard_banner_download_app')}
          </LinkButton>
        </Grid>
      </Grid>
    </div>
  )
}

export default PostcardBanner
